import React, { useCallback } from 'react';
import { createUseStyles, DatePicker } from '@Sage/hoi-poi-ui';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { useWeb5Context } from 'lib/Web5Context';
import { formatDate, getDatePlaceholder } from 'lib/dates';

import styles from './styles';
const useStyles = createUseStyles(styles, 'Date');

function Date({ className, minDate, maxDate, ...props }) {
    const { language, locale } = useWeb5Context();
    const classes = useStyles();

    const format = useCallback(
        (value) => {
            return formatDate(value, locale, 'P');
        },
        [locale],
    );

    const placeholders = getDatePlaceholder(locale);
    const classNames = classnames(classes.root, className);

    return (
        <div className={classNames}>
            <DatePicker
                labelMode="horizontal"
                {...props}
                lang={language}
                formatDate={format}
                placeholder={placeholders}
                minDate={minDate}
                maxDate={maxDate}
            />
        </div>
    );
}

Date.propTypes = {
    uiGrid: PropTypes.string,
};

export default React.memo(Date);
